// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContent_root__1_Y1r","fadeIn":"PageContent_fadeIn__2VPwF","glow":"PageContent_glow__3lA9n"};